import { render, staticRenderFns } from "./TxProductViewportScaler.vue?vue&type=template&id=21ce36d3&scoped=true&"
import script from "./TxProductViewportScaler.vue?vue&type=script&lang=js&"
export * from "./TxProductViewportScaler.vue?vue&type=script&lang=js&"
import style0 from "./TxProductViewportScaler.vue?vue&type=style&index=0&id=21ce36d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce36d3",
  null
  
)

export default component.exports